import React from 'react';
import { FormikHelpers as FormikActions } from 'formik';

import Modal from 'components/Modal';

import CompleteMessage from './CompleteMessage';
import ForgottenPasswordResetForm from './ForgottenPasswordResetForm';

type Props = {
  isComplete: boolean,
  isOpen: boolean,
  message: string | undefined,
  onRequestClose: () => void,
  onSubmit: (values: { password: string}, actions: FormikActions<{ password: string }>) => void,
};

export default function ForgottenPasswordResetModalComponent(props: Props) {
  const {
    isComplete,
    isOpen,
    message,
    onRequestClose,
    onSubmit,
  } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      {isComplete ? <CompleteMessage message={message} /> : <ForgottenPasswordResetForm onSubmit={onSubmit} />}
    </Modal>
  );
}